import React from "react";
import { useTheme } from "styled-components";

import { AVAILABLE_LANGS } from "@typings/globals";

import { Container } from "@components/Layout/Container";
import { CSSGrid } from "@components/Layout/CssGrid";
import { Section } from "@components/Layout/Section";

import * as Styled from "./BecomeBatmain.styled";
import { Image } from "./Image";
import { CallToAction } from "./CallToAction";

const areas = CSSGrid.areas({
  Image,
  CallToAction,
});

areas.all(({ Image, CallToAction }, { repeat }) => [
  repeat(Image, 12),
  repeat(CallToAction, 12),
]);

areas.smallTablet(({ Image, CallToAction }, { repeat, compose }) => [
  compose(repeat(Image, 6), repeat(CallToAction, 6)),
]);

areas.smallDesktop(({ Image, CallToAction }, { repeat, compose }) => [
  compose([undefined], repeat(Image, 5), repeat(CallToAction, 5)),
]);

export const BecomeBatmaid: React.FC<{ language: AVAILABLE_LANGS }> = ({
  language,
}) => {
  const theme = useTheme();

  return (
    <Section overflowHidden backgroundColor="white">
      <Container>
        <Styled.Root>
          <Styled.Bolt />
          <CSSGrid
            areas={areas}
            rowGap={theme.spacing.spacing_24}
            areasProps={{
              CallToAction: {
                language,
              },
            }}
          />
        </Styled.Root>
      </Container>
    </Section>
  );
};
